<div class="header">
  @if (icon(); as iconValue) {
    <fa-icon [icon]="iconValue" aria-hidden="true"></fa-icon>
  }
  <h5 class="m-0">{{ title() }}</h5>
  @if (hasHeaderActions()) {
    <div class="header-actions">
      <ng-content select="[dashboardCardHeaderActions]"></ng-content>
    </div>
  }
</div>

<div class="content">
  <ng-content></ng-content>
</div>

@if (hasFooter()) {
  <div class="footer">
    <ng-content select="[dashboardCardFooter]"></ng-content>
  </div>
}
